let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("fliVL"), load("jiQPW")]).then(() => parcelRequire('gXgjG'));